/**
 * Formats an ISO8601 timestamp as relative time in Romanian
 * Examples: "acum 5 minute", "acum 2 ore", "acum 3 zile"
 */
export function relativeTimeInRo(isoString) {
  if (!isoString) return '';

  const date = new Date(isoString);
  const now = new Date();
  const diffMs = now - date;
  const diffSecs = Math.floor(diffMs / 1000);
  const diffMins = Math.floor(diffSecs / 60);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffSecs < 60) {
    return 'acum câteva secunde';
  } else if (diffMins < 60) {
    if (diffMins === 1) return 'acum un minut';
    return `acum ${diffMins} ${diffMins < 20 ? 'minute' : 'de minute'}`;
  } else if (diffHours < 24) {
    if (diffHours === 1) return 'acum o oră';
    return `acum ${diffHours} ${diffHours < 20 ? 'ore' : 'de ore'}`;
  } else if (diffDays < 7) {
    if (diffDays === 1) return 'acum o zi';
    return `acum ${diffDays} ${diffDays < 20 ? 'zile' : 'de zile'}`;
  } else {
    // Format as date for older content
    return date.toLocaleDateString('ro-RO', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  }
}
